var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1000pt",
    height: 388,
    viewBox: "0 0 1000 291",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#221e1f",
    stroke: "#221e1f",
    strokeWidth: 0.094,
    d: "M841 2c6.4-4.4 11.1 2.3 13.9 7.1 11.4 21.8 21.9 44 33.2 65.8 1.2 3.5 4.8 7.2 2.9 11-26.1 53.3-51.8 106.9-77.8 160.2-4.2 7.8-6.2 18.3-15.2 21.9-13.5 6.7-26.4 15.1-40.8 19.9h-4.4c-3.9-.7-6.8-5.3-5.3-9.1.4-1.1.7-2.3.6-3.5 4-28.1 9.5-56.1 14.5-84.1.2-1.9 1.4-4-.1-5.6-9.8-12.5-22.7-22-33.7-33.4-11.2-11.5-23.5-21.8-34.7-33.4-1.3-1.5-3-3.2-3.1-5.3.1-1 0-2 0-3-.3-1.8.8-3.3 2.3-4.1 10.1-3.6 20.9-4 31.4-5.7 13.6-1.5 27-4.7 40.6-5.6 1.2.1 2.4 0 3.5-.5 6.1-1.5 12.4-2.5 18.7-2.3 1.2.2 2.4.1 3.4-.7 5.4-2.6 7.5-8.6 10.2-13.5 7.7-15.9 15.5-31.6 23.9-47.1 5.3-9.7 8.9-20.5 16-29z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#161314",
    stroke: "#161314",
    strokeWidth: 0.094,
    opacity: 0.64,
    d: "M49.5 5c-.2-2.2 3.5-2.2 4.1-.3-1.4.2-2.8.3-4.1.3z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#221e1f",
    stroke: "#221e1f",
    strokeWidth: 0.094,
    d: "M53.6 4.7c3.7-.4 7.4-.6 11.1-.2 1.2.1 3.5.4 4.7.5 12.5.7 24.3 5.5 35.4 10.8-.2 8-.3 15.9-.9 23.8C92.9 32 80.6 27 67.8 23.3c-1-.5-2.2-.7-3.4-.5-2 0-6 .1-8 .1-1.2.1-3.5.3-4.7.4-8.2 1.4-16.6 4.8-21.9 11.5-2.3 3.2-4 6.9-5.5 10.6-.6 1.2-.8 2.6-.5 4 .4 8 2.8 16.4 8.6 22.2C50.7 89.7 78.6 92.3 98 109c11.8 9.2 21 22.6 22.3 37.8.1 4.5.2 8.9.1 13.4-3 25.2-26 45-50.9 46.8-1.2 0-2.5 0-3.8.1H50.3c-1.3-.1-2.5-.1-3.8 0-15.2-1-29.4-7-43.3-13-.3-2.4-.6-4.9-.9-7.4-.2-1.4-.3-2.9-.3-4.4-.1-1.9-.2-3.8-.3-5.6-.3-3.3-.6-6.5-.8-9.8 14.9 8.7 30.4 16.4 47.5 19.8 1.3.5 2.7.7 4 .5 16.9 1.1 36.1-4.8 43.6-21.3 4.7-12.3 2-27.9-8.3-36.6-18.6-17-45.4-20.3-64.4-36.6-9.2-8.1-18.3-18.1-19.2-31 0-1.2-.2-2.4-.6-3.5C-1.9 31.1 23.2 5.9 49.5 5c1.3 0 2.7-.1 4.1-.3z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#151314",
    stroke: "#151314",
    strokeWidth: 0.094,
    opacity: 0.64,
    d: "M64.7 4.5c.6-2 4.8-1.8 4.7.5-1.2-.1-3.5-.4-4.7-.5z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#221e1f",
    stroke: "#221e1f",
    strokeWidth: 0.094,
    d: "M361.2 5.2c.7-.1 2.1-.2 2.8-.3 30.3 65.3 60.7 130.5 90.6 195.9-8.6 0-17.1.1-25.7.1-5.6-16.1-14-31.1-19.9-47.2-.2-.3-.6-1-.7-1.4-30.9-.6-61.7-.6-92.6 0-.1.3-.4 1-.6 1.3-5.3 13.6-11.6 26.7-17.2 40.2-1.2 2.6-2.3 5.3-4.1 7.5-7.8 0-15.6-.3-23.3-.3 30.1-65.3 60.8-130.4 90.7-195.8m-36.5 129c25.2 1.1 50.6 1.8 75.8-.4h-.9c-12.2-27.7-24.4-55.5-36.9-83.1-13.1 27.6-25.1 55.8-38 83.5z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#100e0e",
    stroke: "#100e0e",
    strokeWidth: 0.094,
    opacity: 0.49,
    d: "M136.6 9.6V11c.1 6.4.3 12.7.2 19v.9l-.1.7c-.4-7.4-.4-14.7-.1-22z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#1a1618",
    stroke: "#1a1618",
    strokeWidth: 0.094,
    opacity: 0.75,
    d: "M136.6 10.2c53.6-.3 107.1-.3 160.6-.1v.9H136.6v-.8z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#100e0e",
    stroke: "#100e0e",
    strokeWidth: 0.094,
    opacity: 0.49,
    d: "M297.2 10.1l.1-.7c.3 7.4.4 14.7.1 22V30c-.2-6.4-.3-12.7-.2-19v-.9z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#1a1718",
    stroke: "#1a1718",
    strokeWidth: 0.094,
    opacity: 0.75,
    d: "M477.5 10.7c16.9-.9 33.9-1.1 50.9-.3h-.7c-16.5.6-33 .9-49.6.3h-.6z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#0d0b0c",
    stroke: "#0d0b0c",
    strokeWidth: 0.094,
    opacity: 0.4,
    d: "M528.4 10.4c2.6-.1 5.2 0 7.9.2-2.9-.1-5.8-.2-8.6-.2h.7z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#231f1f",
    stroke: "#231f1f",
    strokeWidth: 0.094,
    d: "M136.6 11h160.6c-.1 6.3 0 12.6.2 19H228v171.2c-7.3 0-14.6 0-21.9.2-.2-57.1 0-114.3-.1-171.4h-69.2c.1-6.3-.1-12.6-.2-19z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#221e1f",
    stroke: "#221e1f",
    strokeWidth: 0.094,
    d: "M478.1 10.7c16.6.6 33.1.3 49.6-.3 2.8 0 5.7.1 8.6.2.7.2 2.2.6 2.9.8 1.1.5 2.3.8 3.5.7 18.1 1.3 37.2 7.6 49.5 21.7 5.6 7 8.5 15.7 9.9 24.4.1 5 .3 10 .1 15-2.9 23.9-24.2 43.1-47.8 45.6-1.4-.2-3 1.3-1.5 2.4 22.8 26.6 46.3 52.7 68.7 79.6-9.9 0-19.7.1-29.6 0-21-26.9-44.8-51.4-66.1-78-8.3-.5-16.6-.8-24.9-1v1.2c-.1 26.1.2 52.2-.2 78.4-7.6-.2-15.2-.4-22.8-.5.1-63.4-.2-126.8.1-190.2m22.4 18h.6c-.3 25.6-.2 51.1.1 76.6l-.6.1c8.8.6 17.8.5 26.6-.1 1.8-.3 5.3-.7 7-.9.5 1.7 3.7 1.4 3.5-.5 18.4-.8 38.9-11.8 41.5-31.7.1-3.8 0-7.6 0-11.4-.5-5.9-3-11.6-6.7-16.3-8.9-10.2-23-13.6-36-14.5.1-2.1-3.5-2.2-4.1-.4-3.3-.7-6.8-.8-10.2-1-7.2-.3-14.5-.3-21.7.1z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#161314",
    stroke: "#161314",
    strokeWidth: 0.094,
    opacity: 0.64,
    d: "M539.2 11.4c.6-1.6 3.7-1.2 3.5.7-1.2.1-2.4-.2-3.5-.7z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#1a1717",
    stroke: "#1a1717",
    strokeWidth: 0.094,
    opacity: 0.75,
    d: "M104.8 15.8c.9 8.5 1.3 16.9 1.2 25.4-.7-.4-1.5-.7-2.2-1l.1-.6c.6-7.9.7-15.8.9-23.8z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#0b0909",
    stroke: "#0b0909",
    strokeWidth: 0.094,
    opacity: 0.33,
    d: "M51.7 23.3c1.2-.1 3.5-.3 4.7-.4 0 2.3-4.1 2.4-4.7.4z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "#161313",
    stroke: "#161313",
    strokeWidth: 0.094,
    opacity: 0.64,
    d: "M64.4 22.8c1.2-.2 2.4 0 3.4.5-.5 1.7-3.6 1.3-3.4-.5z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "#1a1717",
    stroke: "#1a1717",
    strokeWidth: 0.094,
    opacity: 0.75,
    d: "M500.5 28.7c7.2-.4 14.5-.4 21.7-.1-7 0-14 .2-21.1.1h-.6z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "#131111",
    stroke: "#131111",
    strokeWidth: 0.094,
    opacity: 0.56,
    d: "M532.4 29.6c.6-1.8 4.2-1.7 4.1.4-1.4.1-2.8-.1-4.1-.4z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "#1a1717",
    stroke: "#1a1717",
    strokeWidth: 0.094,
    opacity: 0.75,
    d: "M136.8 30H206c.1 57.1-.1 114.3.1 171.4h-.9c-.4-56.8-.1-113.6-.2-170.4-22.8-.1-45.5.2-68.2-.1V30zm91.2 0h69.4v.8c-22.8.4-45.6.1-68.4.2-.1 56.8.2 113.5-.1 170.3l-.9-.1V30z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "#0d0b0b",
    stroke: "#0d0b0b",
    strokeWidth: 0.094,
    opacity: 0.4,
    d: "M23.8 49.4c-.3-1.4-.1-2.8.5-4 1.6.7 1.4 4-.5 4z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "#141111",
    stroke: "#141111",
    strokeWidth: 0.094,
    opacity: 0.58,
    d: "M3.5 58.2c.4 1.1.6 2.3.6 3.5-1.9.3-2.3-3-.6-3.5z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "#0f0d0d",
    stroke: "#0f0d0d",
    strokeWidth: 0.094,
    opacity: 0.44,
    d: "M602.1 58.2v-.6c.1 5.2.2 10.4.1 15.6.2-5 0-10-.1-15z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "#141213",
    stroke: "#141213",
    strokeWidth: 0.094,
    opacity: 0.6,
    d: "M579.2 60.8c0 3.8.1 7.6 0 11.4.3-3.8.1-7.6 0-11.4z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fill: "#100e0f",
    stroke: "#100e0f",
    strokeWidth: 0.094,
    opacity: 0.47,
    d: "M787.5 92.3c-.2-1.7 2.8-2.2 3.4-.7-1 .8-2.2.9-3.4.7z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fill: "#0d0b0c",
    stroke: "#0d0b0c",
    strokeWidth: 0.094,
    opacity: 0.39,
    d: "M765.3 95.1c-.2-1.8 3-2.1 3.5-.5-1.1.5-2.3.6-3.5.5z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fill: "#221e1f",
    stroke: "#221e1f",
    strokeWidth: 0.094,
    d: "M924.9 96c1.5-.3 4.6-1 6.2-1.3.4 1.7 2.5 1.6 3.9 1.3 15.1 1.9 30.2 4.4 45.4 6.5 6.8.9 13.8 2.6 19.6 6.5v4.7c-2 3.6-4.9 6.6-7.8 9.5-19.9 18.8-39.5 37.9-59.3 56.7-3.7 3.2-5 7.9-4.4 12.7-16.3 1.9-32.7 1.8-49 .8 15-32.5 30.3-64.9 45.4-97.4z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fill: "#0f0d0e",
    stroke: "#0f0d0e",
    strokeWidth: 0.094,
    opacity: 0.45,
    d: "M931.1 94.7c1.4-.6 2.9.2 3.9 1.3-1.4.3-3.5.4-3.9-1.3z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fill: "#131112",
    stroke: "#131112",
    strokeWidth: 0.094,
    opacity: 0.58,
    d: "M534.2 104.4c1.1-.4 2.3-.6 3.5-.5.2 1.9-3 2.2-3.5.5z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fill: "#1a1718",
    stroke: "#1a1718",
    strokeWidth: 0.094,
    opacity: 0.75,
    d: "M501.2 105.3c8.7-.2 17.4 0 26 0-8.8.6-17.8.7-26.6.1l.6-.1z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fill: "#131111",
    stroke: "#131111",
    strokeWidth: 0.094,
    opacity: 0.56,
    d: "M691 113.5c-2 .6-2.1-3.6 0-3 0 1 .1 2 0 3z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fill: "#110f0f",
    stroke: "#110f0f",
    strokeWidth: 0.094,
    opacity: 0.5,
    d: "M552.9 121.2c-1.5-1.1.1-2.6 1.5-2.4.4 1.3-.1 2.1-1.5 2.4z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fill: "#1a1717",
    stroke: "#1a1717",
    strokeWidth: 0.094,
    opacity: 0.75,
    d: "M501 121.8c8.3.2 16.6.5 24.9 1-8.3.1-16.6.2-24.9.2v-1.2z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fill: "#110f10",
    stroke: "#110f10",
    strokeWidth: 0.094,
    opacity: 0.5,
    d: "M399.6 133.8h.9c-25.2 2.2-50.6 1.5-75.8.4 24.9-.4 49.9-.1 74.9-.4z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fill: "#0d0c0c",
    stroke: "#0d0c0c",
    strokeWidth: 0.094,
    opacity: 0.4,
    d: "M120.3 146.8c.1 4.5.2 8.9.1 13.4.1-4.5 0-8.9-.1-13.4z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fill: "#1a1717",
    stroke: "#1a1717",
    strokeWidth: 0.094,
    opacity: 0.75,
    d: "M315.7 152.3c30.9-.6 61.7-.6 92.6 0 .1.4.5 1.1.7 1.4-31.3-1.2-62.6-1.1-93.9-.1.2-.3.5-1 .6-1.3z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fill: "#0c0b0b",
    stroke: "#0c0b0b",
    strokeWidth: 0.094,
    opacity: 0.37,
    d: "M1.7 176.7c.1 1.8.2 3.7.3 5.6-2.4-.2-2.3-4.6-.3-5.6zm760.8 8.9c1.5 1.6.3 3.7.1 5.6-1.6-1.2-1.7-4.4-.1-5.6z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fill: "#0d0b0c",
    stroke: "#0d0b0c",
    strokeWidth: 0.094,
    opacity: 0.39,
    d: "M48.4 186.7c.6-1.7 4.2-1.5 4 .5-1.3.2-2.7 0-4-.5z"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fill: "#181515",
    stroke: "#181515",
    strokeWidth: 0.094,
    opacity: 0.69,
    d: "M2.3 186.7c.3 2.5.6 5 .9 7.4-.4-2.4-.7-4.9-.9-7.4z"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fill: "#110f0f",
    stroke: "#110f0f",
    strokeWidth: 0.094,
    opacity: 0.5,
    d: "M928.5 192.6c-.1.7-.1 1.5-.1 2.2-16.5.3-33.1.3-49.6.1.2-.4.6-1.1.7-1.5 16.3 1 32.7 1.1 49-.8z"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    fill: "#100e0e",
    stroke: "#100e0e",
    strokeWidth: 0.094,
    opacity: 0.48,
    d: "M269.5 201h1c7.7 0 15.5.3 23.3.3h.6c-8.3.4-16.7 1.4-24.9-.3z"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    fill: "#100e0e",
    stroke: "#100e0e",
    strokeWidth: 0.094,
    opacity: 0.49,
    d: "M428.9 200.9c8.6 0 17.1-.1 25.7-.1h.9c-8.8 1.4-17.8 1.5-26.6.1z"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    fill: "#100e0e",
    stroke: "#100e0e",
    strokeWidth: 0.094,
    opacity: 0.48,
    d: "M592 200.8c9.9.1 19.7 0 29.6 0h.9c-10.1 1.6-20.4 1.6-30.5 0z"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    fill: "#100e0e",
    stroke: "#100e0e",
    strokeWidth: 0.094,
    opacity: 0.49,
    d: "M205.2 201.4h.9c7.3-.2 14.6-.2 21.9-.2l.9.1h.7c-8.4.4-16.8.9-25.1.2l.7-.1z"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    fill: "#110f0f",
    stroke: "#110f0f",
    strokeWidth: 0.094,
    opacity: 0.5,
    d: "M478 200.9c7.6.1 15.2.3 22.8.5h.7c-7.8.4-15.7.6-23.5.7v-1.2z"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    fill: "#0c0a0a",
    stroke: "#0c0a0a",
    strokeWidth: 0.094,
    opacity: 0.36,
    d: "M46.5 207.1c1.3-.1 2.5-.1 3.8 0l.4.1c-.4 1.9-4 1.9-4.2-.1z"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    fill: "#191616",
    stroke: "#191616",
    strokeWidth: 0.094,
    opacity: 0.73,
    d: "M50.3 207.1h15.4l-.4.1c-4.7.7-9.9 1.7-14.6 0l-.4-.1z"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    fill: "#0c0a0a",
    stroke: "#0c0a0a",
    strokeWidth: 0.094,
    opacity: 0.36,
    d: "M65.7 207.1c1.3-.1 2.6-.1 3.8-.1-.1 2.1-3.7 2.1-4.2.2l.4-.1z"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    fill: "#070607",
    stroke: "#070607",
    strokeWidth: 0.094,
    opacity: 0.24,
    d: "M907 225.9c9.4.1 18.9.1 28.3.6h-.7c-9.2.4-18.4.5-27.6.5v-1.1z"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    fill: "#221e1f",
    stroke: "#221e1f",
    strokeWidth: 0.094,
    d: "M863.9 227H907c9.2 0 18.4-.1 27.6-.5 2.3 17.3 6.6 34.2 8.2 51.6 1.1 3.6-.5 10.2-5.3 9.9-1 0-2-.1-3 0-10.2-2.4-19.1-8.6-28.4-13.1-17.3-9.1-34.7-17.9-52-26.9 3.2-7 6.5-14.1 9.8-21z"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    fill: "#211d1e",
    stroke: "#211d1e",
    strokeWidth: 0.094,
    opacity: 0.96,
    d: "M122.9 228.2c15.7-2.3 30.2 10.4 32.4 25.6 0 3.8.1 7.6-.2 11.4-1.4 12.8-12.6 22.6-24.8 25.2h-7.6c-4.7-1.3-9.3-3.1-13.4-5.8-6.1-4.4-9.2-11.5-11.9-18.3 0-1.6.1-4.9.2-6.5l-.7-.6.9-.5-.4-6c2.8-12.3 12.6-23.1 25.5-24.5m.9 6.8c-9.8.2-17.6 9.6-19 18.8-.1 3.5-.1 6.9-.1 10.4 1.4 10 9.7 19.4 20.3 19.7 13.1.8 24.8-11.8 23-24.9.6-11.1-6.9-23.4-18.8-24-.2-2.2-5.2-2.2-5.4 0z"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    fill: "#211d1e",
    stroke: "#211d1e",
    strokeWidth: 0.094,
    opacity: 0.95,
    d: "M174.5 227.6c7.4 15.7 13.5 31.9 21.1 47.5 7.1-15.7 13.4-31.8 20.8-47.5 4.2 19.8 7.9 39.7 11.9 59.5-2.4 0-4.7.1-7 .1-2.9-12.7-5-25.6-7.6-38.4-6 14.1-12.1 28.1-17.9 42.2h-.6c-6.7-13.9-12-28.4-18.8-42.3-2.5 13.1-4.6 26.4-8 39.3-1.4-.1-4.3-.1-5.8-.2 2.9-20.2 7.6-40.2 11.9-60.2z"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    fill: "#211d1e",
    stroke: "#211d1e",
    strokeWidth: 0.094,
    opacity: 0.96,
    d: "M235.8 252.8c2-14.6 16.9-27 31.8-24.4 13.1.8 23.8 12.8 25.7 25.3 0 3.8 0 7.7-.2 11.5-1.4 12.8-12.6 22.6-24.8 25.2h-7.5c-12.5-2.3-23.4-12.4-25.2-25.1 0-4.2.1-8.4.2-12.5m26-17.8c-10.2.6-18 10.1-19.2 19.8-.1 3.2 0 6.3 0 9.4 1.6 8.5 7.7 17.3 16.8 18.7-.4 1.9 2.9 2.3 3.4.6 12 2 23.3-9.8 23.3-21.5 1.7-11.9-5.9-26.2-18.9-27-.2-2.2-5.2-2.2-5.4 0z"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    fill: "#151213",
    stroke: "#151213",
    strokeWidth: 0.094,
    opacity: 0.61,
    d: "M323.9 228.5c1.1-.9 2.6-1.5 4-.9-.6 1.7-2.7 1.4-4 .9z"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    fill: "#211d1e",
    stroke: "#211d1e",
    strokeWidth: 0.094,
    opacity: 0.96,
    d: "M327.9 227.6c6.8 1.5 13.6 3 20.2 4.8 0 1.9-.1 5.8-.2 7.7-4.1-2-8.1-4.5-12.7-5.2-3.2-.3-6.3-.6-9.5-.4-15.1 3.4-21.6 22.1-15.7 35.5 2.1 7 9.2 10.2 14.8 13.8 1.3 1.1 3 .5 4.2-.2h2.9c1.3.7 2.9 1.1 4.2.1 3.4-1.8 6.8-3.5 10.2-5.3.8 1.9 1.5 3.9 2.2 5.9-3.9 3.1-8.5 5.2-13.3 6.5-2.8.1-5.6.1-8.4.1-12-2.5-22.9-11.9-25.5-24.1-.5-8.4-1-18 4.2-25.3 4.6-6.1 11.2-10.6 18.4-13 1.3.5 3.4.8 4-.9z"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    fill: "#161314",
    stroke: "#161314",
    strokeWidth: 0.094,
    opacity: 0.65,
    d: "M412.8 228.4c1.7-1 3.7-1 5.4-.1-1.7 1-3.7 1-5.4.1z"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    fill: "#211e1e",
    stroke: "#211e1e",
    strokeWidth: 0.094,
    opacity: 0.97,
    d: "M407.2 228.3c.4 0 1.3 0 1.7.1 1.6.8 3.7 1.2 5.2-.1 5.5 2.8 11.6 5.1 15.5 10 6.3 6.7 6.9 16.2 7.9 24.8-1.8.5-1.7 2.6-1.2 4-3 11.6-12.4 20.9-24.1 23.7h-8.4c-12.9-2.9-23.8-14.1-25.2-27.5 0-2.9 0-5.7.2-8.5.8-12.7 11.4-22.5 23-26.4 1.7.9 3.7.9 5.4-.1m-2.4 6.7c-12.8 1-20.4 15.1-18.8 27 .2 9.3 6.9 19 16.3 20.9-.3 1.9 3 2.3 3.5.6 11.3 2.3 21.9-7.5 23.4-18.3.1-3.8.1-7.6.1-11.4-1.4-9.2-9.3-18.6-19.1-18.8-.2-2.2-5.2-2.2-5.4 0z"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    fill: "#151213",
    stroke: "#151213",
    strokeWidth: 0.094,
    opacity: 0.61,
    d: "M408.9 228.4c1.6-.8 3.6-1.2 5.2-.1-1.5 1.3-3.6.9-5.2.1z"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    fill: "#100e0e",
    stroke: "#100e0e",
    strokeWidth: 0.094,
    opacity: 0.49,
    d: "M448.5 227l.6.7c.1 20.1-.2 40.2-.1 60.3h6c0-14.5-.1-28.9.1-43.4.3.3.8.9 1 1.2.2 14.4-.1 28.8-.1 43.2h-8c0-20.7-.3-41.3.5-62z"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    fill: "#221e1f",
    stroke: "#221e1f",
    strokeWidth: 0.094,
    d: "M449.1 227.7c13.2 15.2 26.7 30.2 39.8 45.5.2.3.7 1 .9 1.3.2-14.8.2-29.7.3-44.5 1.9-.1 3.9-.1 5.8 0-.1 20 1.2 40.1-1 60-12.8-14.8-25.5-29.8-38.8-44.2-.2-.3-.7-.9-1-1.2-.2 14.5-.1 28.9-.1 43.4h-6c-.1-20.1.2-40.2.1-60.3z"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    fill: "#211d1e",
    stroke: "#211d1e",
    strokeWidth: 0.094,
    opacity: 0.96,
    d: "M503.5 288c9.6-20 18.4-40.4 28.3-60.3 9.2 20 18.6 40 27.8 60.1-3 0-5.8 0-8.7.1-1.3-5-3.4-9.7-5.4-14.4-9.5-.3-19-.4-28.6 0-2 5.1-4 10.1-6.2 15-2.4-.2-4.8-.4-7.2-.5m16.5-20h22.9c-3.6-8.5-7.3-16.9-11.2-25.3-4.1 8.3-7.8 16.8-11.7 25.3zm77.4-38.6c7.2-2.7 14.9-.4 21.7 2.2v7.2c-4.6-2-9.2-4.1-14.2-4.6-6.8-1.8-14.4 6.3-9.9 12.8 5 5.2 12.1 7.3 18.2 11 4.9 3 7.9 8.2 10.7 13.1-1.5 1.5-1.5 4-.2 5.7-2.7 6.7-8.4 12.3-15.5 14-2.8.1-5.6.1-8.4 0-6.7-1-13.9-4.3-14.7-12 7.7 2.3 15.4 5.3 23.6 5.3 3-2.5 5.8-5.2 8.3-8.2 0-1.2-.1-3.6-.1-4.8-8.8-9.9-23.5-12.8-30-25 .2-1.7.7-5.2.9-6.9 2-4.1 5-8.4 9.6-9.8z"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    fill: "#221e1f",
    stroke: "#221e1f",
    strokeWidth: 0.094,
    opacity: 0.98,
    d: "M0 229.8c10.3.8 21.7-1.6 31.1 4.2 4.1 2.8 7.3 7.7 6.9 12.9 1 10.3-9 18.2-18.7 18.2-4 .2-8 .3-12 .4l-.1.8c-.3 7.2-.4 14.4-.8 21.6-1.6.1-4.8.4-6.4.6v-58.7m6.5 5.8h.6C7 243.8 7 252 7 260.2c1.7-.2 5-.6 6.7-.8 1.1 1.9 5.5 1.9 5.6-.5 8.2.4 14.6-8.5 10.8-16-2.1-5.3-8.3-6.3-13.3-7l.7.1c-2.8-.1-8.3-.3-11-.4z"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    fill: "#100e0e",
    stroke: "#100e0e",
    strokeWidth: 0.094,
    opacity: 0.49,
    d: "M48 289c.2-19.8-.6-39.6.5-59.4.7 19.5.5 38.9.5 58.4h5.9c.1-8.1.1-16.1.2-24.1 2.7.1 5.4.4 8.1.6-1.8.1-5.4.5-7.2.6V289h-8z"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    fill: "#221e1f",
    stroke: "#221e1f",
    strokeWidth: 0.094,
    opacity: 0.98,
    d: "M48.5 229.6c6.2.4 12.5 0 18.7 1 1.1.3 2.3.5 3.5.5 7.3.1 15.3 5.8 15.3 13.6v4.6c0 7.7-7.6 12.5-14.2 14.6 6.2 8.2 13.3 15.7 19.8 23.8-2.7.3-5.4.6-8.2.9-6.6-8.2-13.9-15.8-20.2-24.1-2.7-.2-5.4-.5-8.1-.6-.1 8-.1 16-.2 24.1H49c0-19.5.2-38.9-.5-58.4m6.4 5.2c.1 8.3.3 16.6.8 24.9v-.7c7.6-.1 22 .8 23.3-9.7 2.2.1 2.2-4.7-.1-4.5-.7-6.6-8.2-8.6-13.7-8.9-2.6-.3-7.7-.8-10.3-1.1z"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    fill: "#100e0f",
    stroke: "#100e0f",
    strokeWidth: 0.094,
    opacity: 0.47,
    d: "M67.2 230.6c.5-1.7 3.7-1.4 3.5.5-1.2 0-2.4-.2-3.5-.5z"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    fill: "#080707",
    stroke: "#080707",
    strokeWidth: 0.094,
    opacity: 0.27,
    d: "M359 289.1c.2-19.8-.6-39.6.5-59.4.7 19.4.5 38.7.5 58.1 1.7.1 5.1.4 6.8.6h.7c-2.8.3-5.7.5-8.5.7z"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    fill: "#231e20",
    stroke: "#231e20",
    strokeWidth: 0.094,
    d: "M359.5 229.7c1.9.1 5.6.3 7.5.3 0 19.5.2 38.9-.2 58.4-1.7-.2-5.1-.5-6.8-.6 0-19.4.2-38.7-.5-58.1z"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    fill: "#110f0f",
    stroke: "#110f0f",
    strokeWidth: 0.094,
    opacity: 0.5,
    d: "M489.1 230.1l1-.1c-.1 14.8-.1 29.7-.3 44.5-.2-.3-.7-1-.9-1.3-.3-14.4-.1-28.7.2-43.1z"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    fill: "#070606",
    stroke: "#070606",
    strokeWidth: 0.094,
    opacity: 0.24,
    d: "M495.9 230l1 .1c.4 20.3 0 40.6.1 60.9h-1.2c-.2-.2-.7-.7-.9-1 2.2-19.9.9-40 1-60z"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    fill: "#231e20",
    stroke: "#231e20",
    strokeWidth: 0.094,
    d: "M567 230h7c-.1 19.3.6 38.7-.7 58h-5.5c-1.4-19.3-.7-38.7-.8-58z"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    fill: "#151212",
    stroke: "#151212",
    strokeWidth: 0.094,
    opacity: 0.61,
    d: "M123.8 235c.2-2.2 5.2-2.2 5.4 0h-5.4zm138 0c.2-2.2 5.2-2.2 5.4 0h-5.4z"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    fill: "#0e0c0c",
    stroke: "#0e0c0c",
    strokeWidth: 0.094,
    opacity: 0.41,
    d: "M325.7 234.5c3.2-.2 6.3.1 9.5.4-3.2-.2-6.3-.3-9.5-.4z"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    fill: "#151212",
    stroke: "#151212",
    strokeWidth: 0.094,
    opacity: 0.61,
    d: "M404.8 235c.2-2.2 5.2-2.2 5.4 0h-5.4z"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    fill: "#1a1717",
    stroke: "#1a1717",
    strokeWidth: 0.094,
    opacity: 0.75,
    d: "M6.5 235.6c2.7.1 8.2.3 11 .4l-.7-.1c-3.2-.1-6.4-.2-9.7-.3h-.6z"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    fill: "#131112",
    stroke: "#131112",
    strokeWidth: 0.094,
    opacity: 0.58,
    d: "M54.9 234.8c2.6.3 7.7.8 10.3 1.1-3-.1-6.1-.1-9.1-.1-.1 7.7-.2 15.5-.4 23.2v.7c-.5-8.3-.7-16.6-.8-24.9z"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    fill: "#0f0d0d",
    stroke: "#0f0d0d",
    strokeWidth: 0.094,
    opacity: 0.44,
    d: "M585.4 243.9c.6-1.2 1.8-3.5 2.4-4.7-.2 1.7-.7 5.2-.9 6.9-.3-.6-1.1-1.7-1.5-2.2z"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    fill: "#171515",
    stroke: "#171515",
    strokeWidth: 0.094,
    opacity: 0.69,
    d: "M78.9 244.8c2.3-.2 2.3 4.6.1 4.5 0-1.5-.1-3-.1-4.5z"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    fill: "#0e0c0c",
    stroke: "#0e0c0c",
    strokeWidth: 0.094,
    opacity: 0.42,
    d: "M86 244.7c2.2-.1 2.2 4.6 0 4.6v-4.6z"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    fill: "#161414",
    stroke: "#161414",
    strokeWidth: 0.094,
    opacity: 0.65,
    d: "M96.9 259.2c.1-1.6.4-4.9.5-6.5l.4 6-.9.5z"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    fill: "#161313",
    stroke: "#161313",
    strokeWidth: 0.094,
    opacity: 0.64,
    d: "M235.6 265.3c-.2-4.2.1-8.4.2-12.5-.1 4.1-.2 8.3-.2 12.5z"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    fill: "#0c0b0c",
    stroke: "#0c0b0c",
    strokeWidth: 0.094,
    opacity: 0.38,
    d: "M104.7 264.2c0-3.5 0-6.9.1-10.4-.2 3.5-.2 6.9-.1 10.4z"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    fill: "#0d0c0c",
    stroke: "#0d0c0c",
    strokeWidth: 0.094,
    opacity: 0.4,
    d: "M155.3 253.8c.1 3.8 0 7.6-.2 11.4.3-3.8.2-7.6.2-11.4z"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    fill: "#0e0c0c",
    stroke: "#0e0c0c",
    strokeWidth: 0.094,
    opacity: 0.42,
    d: "M293.3 253.7c.1 3.8-.1 7.7-.2 11.5.2-3.8.2-7.7.2-11.5z"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    fill: "#0c0a0b",
    stroke: "#0c0a0b",
    strokeWidth: 0.094,
    opacity: 0.36,
    d: "M429.3 253.8c0 3.8 0 7.6-.1 11.4.3-3.8.1-7.6.1-11.4z"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    fill: "#0e0c0d",
    stroke: "#0e0c0d",
    strokeWidth: 0.094,
    opacity: 0.43,
    d: "M242.6 264.2c0-3.1-.1-6.2 0-9.4-.1 3.2-.1 6.3 0 9.4z"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    fill: "#090808",
    stroke: "#090808",
    strokeWidth: 0.094,
    opacity: 0.29,
    d: "M378.6 263.3c-.2-2.9 0-5.7.2-8.5-.2 2.8-.2 5.6-.2 8.5z"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    fill: "#0b090a",
    stroke: "#0b090a",
    strokeWidth: 0.094,
    opacity: 0.34,
    d: "M13.7 259.4c1.9-.2 3.7-.4 5.6-.5-.1 2.4-4.5 2.4-5.6.5z"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    fill: "#151212",
    stroke: "#151212",
    strokeWidth: 0.094,
    opacity: 0.61,
    d: "M97.6 259.8c-.1 1.6-.2 4.9-.2 6.5-.2-1.5-.5-4.5-.6-6l.8-.5z"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    fill: "#131111",
    stroke: "#131111",
    strokeWidth: 0.094,
    opacity: 0.56,
    d: "M436.3 267.1c-.5-1.4-.6-3.5 1.2-4 .4 1.5-.2 2.9-1.2 4z"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    fill: "#181515",
    stroke: "#181515",
    strokeWidth: 0.094,
    opacity: 0.7,
    d: "M7.3 265.5c4-.1 8-.2 12-.4-4 .5-8.1.8-12.1 1.2l.1-.8z"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    fill: "#100e0e",
    stroke: "#100e0e",
    strokeWidth: 0.094,
    opacity: 0.47,
    d: "M616.9 271.1c0 1.2.1 3.6.1 4.8-1.4-1.2-1.5-3.5-.1-4.8z"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    fill: "#0a0909",
    stroke: "#0a0909",
    strokeWidth: 0.094,
    opacity: 0.32,
    d: "M623.9 271.1c1.1 1.7 1 3.6-.2 5.7-1.3-1.7-1.3-4.2.2-5.7z"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    fill: "#1a1717",
    stroke: "#1a1717",
    strokeWidth: 0.094,
    opacity: 0.75,
    d: "M516.9 273.5c9.6-.4 19.1-.3 28.6 0-9.5.4-19 .5-28.6 0z"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    fill: "#0e0c0c",
    stroke: "#0e0c0c",
    strokeWidth: 0.094,
    opacity: 0.42,
    d: "M747.5 278.8c-1.7-.5-1.3-3.7.6-3.5.1 1.2-.2 2.4-.6 3.5z"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    fill: "#141212",
    stroke: "#141212",
    strokeWidth: 0.094,
    opacity: 0.6,
    d: "M346.3 278.4c1-.5 2-1 2.9-1.5-.2 2.4-.4 4.9-.7 7.4-.7-2-1.4-4-2.2-5.9z"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    fill: "#0d0b0c",
    stroke: "#0d0b0c",
    strokeWidth: 0.094,
    opacity: 0.39,
    d: "M259.4 282.9c1.1 0 2.3.2 3.4.6-.5 1.7-3.8 1.3-3.4-.6z"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    fill: "#0c0b0c",
    stroke: "#0c0b0c",
    strokeWidth: 0.094,
    opacity: 0.38,
    d: "M324.8 283.8c1.1-1.3 3-.9 4.2-.2-1.2.7-2.9 1.3-4.2.2z"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    fill: "#0c0a0b",
    stroke: "#0c0a0b",
    strokeWidth: 0.094,
    opacity: 0.36,
    d: "M331.9 283.6c1.2-.8 3.1-1.3 4.2.1-1.3 1-2.9.6-4.2-.1z"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    fill: "#0e0d0e",
    stroke: "#0e0d0e",
    strokeWidth: 0.094,
    opacity: 0.44,
    d: "M402.3 282.9c1.2 0 2.4.2 3.5.6-.5 1.7-3.8 1.3-3.5-.6z"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    fill: "#100e0e",
    stroke: "#100e0e",
    strokeWidth: 0.094,
    opacity: 0.49,
    d: "M91.6 287.7l.9-.1c-3.3.4-6.5.9-9.8 1.1l.7-.1c2.8-.3 5.5-.6 8.2-.9z"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    fill: "#0e0d0d",
    stroke: "#0e0d0d",
    strokeWidth: 0.094,
    opacity: 0.44,
    d: "M221.3 287.2c2.3 0 4.6-.1 7-.1.1.5.4 1.7.5 2.3-2.4-.3-4.8-.7-7.2-1-.1-.3-.3-.9-.3-1.2zm281.3.7l.9.1c2.4.1 4.8.3 7.2.5l.7.1c-3.1-.2-5.9-.2-8.8-.7z"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    fill: "#0d0c0c",
    stroke: "#0d0c0c",
    strokeWidth: 0.094,
    opacity: 0.4,
    d: "M550.9 287.9c2.9-.1 5.7-.1 8.7-.1h.9c-3.2.5-6.4 1.1-9.6.1z"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    fill: "#110e0e",
    stroke: "#110e0e",
    strokeWidth: 0.094,
    opacity: 0.5,
    d: "M0 288.5c1.6-.2 4.8-.5 6.4-.6-.9 2.2-3.1 2.6-6.4 1.1v-.5z"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    fill: "#100e0e",
    stroke: "#100e0e",
    strokeWidth: 0.094,
    opacity: 0.47,
    d: "M162.6 287.8c1.5.1 4.4.1 5.8.2-.1 2.7-5.8 2.3-5.8-.2z"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    fill: "#110e0e",
    stroke: "#110e0e",
    strokeWidth: 0.094,
    opacity: 0.5,
    d: "M567.8 288h5.5c-.3 2.2-5.3 2.2-5.5 0z"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    fill: "#100e0e",
    stroke: "#100e0e",
    strokeWidth: 0.094,
    opacity: 0.49,
    d: "M752.8 287.9h4.4c.2 2.3-4.6 2.3-4.4 0z"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    fill: "#100e0e",
    stroke: "#100e0e",
    strokeWidth: 0.094,
    opacity: 0.47,
    d: "M934.5 288c1-.1 2 0 3 0 .6 2.1-3.6 2-3 0z"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    fill: "#0b0909",
    stroke: "#0b0909",
    strokeWidth: 0.094,
    opacity: 0.33,
    d: "M122.7 290.4h7.6l-.4.6h-6.8l-.4-.6zm138.1 0h7.5l-.4.6h-6.7l-.4-.6z"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    fill: "#0a0808",
    stroke: "#0a0808",
    strokeWidth: 0.094,
    opacity: 0.3,
    d: "M326.8 290.9c2.8 0 5.6 0 8.4-.1l-.9.2h-6.7l-.8-.1z"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    fill: "#0a0909",
    stroke: "#0a0909",
    strokeWidth: 0.094,
    opacity: 0.31,
    d: "M403.8 290.8h8.4l-.9.2h-6.5l-1-.2z"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    fill: "#0d0c0c",
    stroke: "#0d0c0c",
    strokeWidth: 0.094,
    opacity: 0.4,
    d: "M599.8 290.8c2.8.1 5.6.1 8.4 0l-.8.2h-6.7l-.9-.2z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.6d7faac844601d495298fba0966067ab.svg";
export { ForwardRef as ReactComponent };